import axios from 'axios'

axios.defaults.headers['Content-Type'] = 'application/json'

export default {
  getSearchItems({
    take,
    skip,
    searchType,
    matchAnyTag,
    activeCategories = [],
    terms = null,
    sorting = null,
    language = null
  }) {
    const categories = activeCategories.filter((c) => c.uid.startsWith('rdb:')).map((c) => c.uid)
    const tags = activeCategories.filter((c) => c.uid.startsWith('tdb:')).map((c) => c.uid)
    const params = {
      skip,
      take,
      categories: categories.length ? categories : null,
      tags: tags.length ? tags : null,
      matchAnyTag,
      terms: terms?.length ? terms : null,
      sorting
    }
    return axios.get(`/api/content/${language}/${searchType}/search`, { params })
  },
  getAutoSuggestions(term = null, language, searchType) {
    const params = {
      take: 3,
      terms: term !== null ? [term] : null
    }
    return axios.get(`/api/content/${language}/${searchType}/search`, { params })
  }
}
